import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import CreateRecommendation from "../recommendationWorkflow/CreateRecommendation.jsx"
import MuiDialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import CancelRoundedIcon from "@material-ui/icons/CancelRounded";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import SkeletonList from "../skeleton/skeletonList";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  Grid,
  TextField,
} from "@material-ui/core";
import MuiTableHead from "@material-ui/core/TableHead";
import ErrorHandler from "../updateHandlers/ErrorHandler";
import Autocomplete from "@material-ui/lab/Autocomplete";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1)
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
});
const useStyles = makeStyles(() => ({
  dialogContainer:{
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    width: "100vw", 
    overflow: "hidden",
    position:"fixed",
    right:0
  },
  dialogAction: {
    justifyContent: "flex-start",
  },
  label: {
    fontWeight: "bold",
  },
  chip: {
    alignSelf: "flex-end",
    backgroundColor: "white",
    margin: "0px 5px",
  },
  tableHead: {
    color: "white",
  },
  recommendationInput: {
    width: "340px",
  },
  btn_grp_style:{
    display:'flex',
    alignItems:'end'
  },
  create_btn_style:{
    background:'#FFFFFF',
    borderRadius:'20px !important',
    border:'1px solid #BFB8AF'
  },
  closeBarContainer:{
    width: '5%',
    height:'100vh',
    backgroundColor:"#262523",
    justifyContent: 'center',
    display: 'flex'
  },
  searchRecContainer:{
    width:"95%"
  }
}));

const Dialog = withStyles(() => ({
  paper: {
    maxWidth:'none',
    width:'70%',
    backgroundColor: "#F6F6F6",
    margin:'unset !important'
  },
  paperWidthSm: {
    maxHeight: 'none',
    height: '100%',
    width:'80%',
    maxWidth: '80%'
  }
}))(MuiDialog);

const TableHead = withStyles(() => ({
  root: {
    backgroundColor: "#666666",
    color: "white",
  },
}))(MuiTableHead);

export default function RecommendationDialog(props) {
  const classes = useStyles();
  const {
    open,
    scroll,
    allRecommendation,
    handleCloseDialog,
    handleAddRecommendation,
  } = props;
  const recommendation = useSelector((state) => state.recommendation);
  const recommendationlistitems = allRecommendation;
  const [error, setErrorState] = useState();
  const [value, setValue] = useState(null);
  const [recommendations, setRecommendations] = useState("");
  const [openCreate, setOpenCreate] = useState(false);
  
  useEffect(() => {
    if (allRecommendation) {
      let sortedRecommendations = recommendationlistitems.sort((a,b) =>  b.id - a.id)
      setRecommendations(sortedRecommendations);
    }
    if(value){handleRecommendationChange(value)}
  }, [recommendationlistitems]);

  const handleRecommendationChange = (newValue) => {
    setValue(newValue);
    if (newValue) {
      setRecommendations(
        recommendationlistitems.filter((recommendation) => {
          return recommendation.id === newValue.id;
        })
      );
    }
    else{
      setRecommendations(recommendationlistitems)
    }
  };

  const handleClose = () =>{
    setOpenCreate(false)
  }

  return (
    <Dialog
      open={open}
      PaperProps={{
        className: classes.dialogContainer 
      }}
    >
      <Grid container direction="row">
        <Grid item className={classes.closeBarContainer}>
          <div>
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={handleCloseDialog}
              >
              <CancelRoundedIcon style={{color:"#ffffff"}} />
            </IconButton>
          </div>
        </Grid>
        <Grid item className={classes.searchRecContainer}>
          <DialogTitle>
            <Grid container direction="row">
                <div className={classes.root}>
                  {recommendation.loading && <SkeletonList />}
                  {recommendation.error && (
                    <>
                      <SkeletonList />
                      <Snackbar
                        message={recommendation.error}
                        open={true}
                        onClose={() => setErrorState(false)}
                        autoHideDuration={3000}
                      />
                    </>
                  )}
                  <Grid container
                    direction="row"
                    justifyContent="space-between"
                    style={{ marginBottom: "2em", marginTop: "1em" }}>
                      <Grid item >
                        <Autocomplete
                          className={classes.recommendationInput}
                          id="recc_searchtext"
                          value={value}
                          options={recommendationlistitems}
                          getOptionLabel={(option) => option.description ? option.description : ''}
                          onChange={(event, newValue) => {
                            handleRecommendationChange(newValue);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Search Recommendations"
                            />
                          )}
                        />
                      </Grid>
                      <Grid item>
                        <Button className={classes.create_btn_style} onClick={() => setOpenCreate(true)}>
                          Create new recommendation
                        </Button>
                      </Grid>
                  </Grid>
                  <Grid style={{ overflow: "auto", maxHeight:"calc(100vh - 200px)", overflowY:"scroll", width:"100%", marginTop: 30 }}>                 
                      <TableContainer component={Paper}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell />
                              <TableCell>S.No</TableCell>
                              <TableCell>Recommendations</TableCell>
                              <TableCell />
                            </TableRow>
                          </TableHead>
                          {!recommendation.loading &&
                            recommendations &&
                            recommendations
                              .sort((a, b) => b.id - a.id)
                              .map((recommendationlistitem, index) => {
                                return (
                                  <TableBody  key={`data${recommendationlistitem.id}`}>
                                    <TableCell />
                                    <TableCell>
                                      <Typography>
                                        {recommendationlistitem.id}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography>
                                        {recommendationlistitem.description}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Button
                                        className={`btn-primary`}
                                        style={{color:"#52A1C2"}}
                                        onClick={() => {
                                          handleAddRecommendation(
                                            recommendationlistitem
                                          );
                                        }}
                                      >
                                        + Add
                                      </Button>
                                    </TableCell>
                                  </TableBody>
                                );
                              })}
                        </Table>
                      </TableContainer>
                    </Grid>
                 </div>
              </Grid>
          </DialogTitle>
        </Grid>
      </Grid>
      
      {recommendation.error && (
        <ErrorHandler message={recommendation.error} />
      )}

      {/* Rendering Create Recommendation Component */}
      {openCreate && (
        <CreateRecommendation
          open={openCreate}
          onClose={(e) => handleClose()}
      />
      )}
    </Dialog>
  );
}
